export const AUTH_BASE_PATH = 'auth';
